module.exports = __webpack_public_path__ + "img/dc.51320dff.png";